import { ChevronDown, Trash2, X } from "lucide-react";

interface ActionsDropdownProps {
  isOpen: boolean;
  selectedCount: number;
  onToggle: () => void;
  onDeleteSelected: () => void;
  onClearSelection: () => void;
}

export function ActionsDropdown({
  isOpen,
  selectedCount,
  onToggle,
  onDeleteSelected,
  onClearSelection,
}: ActionsDropdownProps) {
  return (
    <div className="relative">
      <button
        className={`inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-semibold transition-all border border-black/5 h-11 px-5 py-2 gap-2 shadow-sm ${isOpen
          ? "bg-white text-accent border-accent/20"
          : "bg-white/50 backdrop-blur-sm hover:bg-white text-foreground/80 hover:text-foreground"
          }`}
        onClick={onToggle}
      >
        Acciones{" "}
        {selectedCount > 0 && (
          <span className="ml-1 bg-accent px-1.5 py-0.5 rounded text-[10px] text-white">
            {selectedCount}
          </span>
        )}
        <ChevronDown
          className={`size-4 opacity-70 transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={onToggle} />
          <div className="absolute left-0 mt-2 w-56 rounded-2xl bg-white/90 backdrop-blur-xl border border-white/40 shadow-[0_20px_40px_-12px_rgba(0,0,0,0.15)] overflow-hidden z-20 animate-in fade-in slide-in-from-top-2 duration-200">
            <div className="p-2 space-y-1">

              <div className="h-px bg-black/5 mx-2 my-1" />

              <button
                onClick={onDeleteSelected}
                disabled={selectedCount === 0}
                className={`flex w-full items-center gap-3 px-3 py-2.5 text-sm font-bold rounded-xl transition-colors ${selectedCount > 0
                  ? "text-red-500 hover:bg-red-50/50"
                  : "text-red-500/30 cursor-not-allowed"
                  }`}
              >
                <Trash2 className="size-4" />
                Eliminar seleccionadas
              </button>

              <button
                onClick={onClearSelection}
                disabled={selectedCount === 0}
                className={`flex w-full items-center gap-3 px-3 py-2.5 text-sm font-medium rounded-xl transition-colors ${selectedCount > 0
                  ? "text-foreground/50 hover:bg-black/5"
                  : "text-foreground/20 cursor-not-allowed"
                  }`}
              >
                <X className="size-4" />
                Deseleccionar todo
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
